import { createReducer, updateIn, deleteIn, isMatchId } from '../../helpers';
import { api } from '../../actions';

const initialState = {
    card: {},
};

function updateDomain(state, action) {
    state.card.domain = action.result.domain;
}

function updateCard(state, action) {
    state.card = action.result;
}

export default createReducer(initialState, {
    [api.card.update.success]: updateCard,
    [api.card.patch.success]: updateCard,
    [api.card.messengers.create.success]: (state, action) => {
        state.card.messengers.push(action.result);
    },
    [api.card.messengers.update.success]: (state, action) => {
        updateIn(state.card.messengers, isMatchId(action.messengerId), action.result);
    },
    [api.card.messengers.delete.success]: (state, action) => {
        deleteIn(state.card.messengers, isMatchId(action.messengerId));
    },
    [api.card.messengers.sort.success]: (state, action) => {
        state.card.messengers = action.result;
    },
    [api.card.links.create.success]: (state, action) => {
        state.card.links.push(action.result);
    },
    [api.card.links.update.success]: (state, action) => {
        updateIn(state.card.links, isMatchId(action.linkId), action.result);
    },
    [api.card.links.delete.success]: (state, action) => {
        deleteIn(state.card.links, isMatchId(action.linkId));
    },
    [api.card.domain.connect.success]: updateDomain,
    [api.card.domain.disconnect.success]: updateDomain,
    [api.products.create.success]: (state) => {
        state.card.products.count++;
    },
    [api.products.delete.success]: (state) => {
        state.card.products.count = Math.max(0, state.card.products.count - 1);
    },
});
